import { useEffect, useState } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { fetchCampaignData } from 'workflow/Workflow.actions'

import Loader from 'common/components/loaders/Loader'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { useSelectedComponentElement } from 'features/unifiedFlow/contentPage/hooks'
import useTweakSuccess from 'features/unifiedFlow/contentPage/hooks/useTweakSuccess'

import TweakVariantModal from '../../../components/tweakVariantModal'
import useVariantTweakWebsocketSubscription from '../../../hooks/useVariantTweakWebsocketSubscription'

import AiControlLineSection from './AiControlLineSection'
import OptimizeResultsTable from './OptimizeResultsTable'

type Props = {
  isReadOnly: boolean
}

const OptimizeResults = ({ isReadOnly = false }: Props) => {
  const { tweakSuccessVariantIds, onTweakSuccess } = useTweakSuccess()
  const flags = useFlags()
  const [hasAppliedAiControlLine, setHasAppliedAiControlLine] = useState(false)

  useVariantTweakWebsocketSubscription({ onTweakSuccess })

  const dispatch = useAppDispatch()
  const { data: selectedElement } = useSelectedComponentElement()

  const {
    isLoading,
    isWaitingState: { isWaiting },
  } = useAppSelector((state) => state.campaignStates)

  useEffect(() => {
    if (!!selectedElement?.campaign_id) {
      dispatch(fetchCampaignData(selectedElement?.campaign_id))
    }
  }, [dispatch, selectedElement?.campaign_id])

  return isLoading || isWaiting ? (
    <Loader className="m-auto" />
  ) : (
    <>
      <div
        className="flex flex-col w-full gap-y-8"
        data-testid="optimizeResults"
      >
        {flags.jacquardGeneratedControl && (
          <AiControlLineSection
            onApplied={() => setHasAppliedAiControlLine(true)}
          />
        )}
        <OptimizeResultsTable
          isReadOnly={isReadOnly}
          tweakSuccessVariantIds={tweakSuccessVariantIds}
          hasAppliedAiControlLine={hasAppliedAiControlLine}
        />
      </div>
      <TweakVariantModal campaignType="linguo" />
    </>
  )
}

export default OptimizeResults
